// react
import React from "react";
// modals
import { ModalProvider } from "../../../context/modalContext.tsx";
import Agent from "./agent/agent.tsx";
import CheckOtp from "./agent/checkOtp.tsx";
import Photograph from "./photographer/photograph.tsx";
import Cv from "./photographer/cv.tsx";

const Modal = () => {
    return (
        <>
            <ModalProvider>
                <Agent />
                <CheckOtp />
                <Photograph />
                <Cv />
            </ModalProvider>
        </>
    )
}

export default Modal;